SectionProfile.Event.CreateSuccess = Class(
	/**
	 * @lends {SectionProfile.Event.CreateSuccess#}
	 */
	{
		__NAME: 'SectionProfile.Event.CreateSuccess',

		bodyClass: 'small-nav grey full-container',

		route() {
			this.id = Number(this.url.get.v('id'));
			if (!this.id) {
				Section.navigate(D.url('/'));
			}
		},

		draw() {
			if (!D.ID) {
				Section.navigate(D.url('/'));
				return;
			}
			new RPC('/api/web_rpc.php').send('getPurchaseInfo', {
				id: this.id
			}, this._onInfo);
		},

		_onInfo(re) {
			if (re.error) {
				Section.navigate(D.url('/'));
				return;
			}
			this.node = mkE({
				tag: 'div',
				id: 'purchase-success',
				className: 'container'
			}).append(this.layout.ct());

			const codeType = re.codes.length > 1 ? 'multiple' : 'single';

			T.success(D.Lang.get('profile.team.purchase.' + codeType + '.purchased'), true, true).append(this.node);

			mkE({
				tag: 'h2',
				text: D.Lang.get('profile.team.purchase.' + codeType + '.thanks')
			}).append(this.node);

			let text = mkE({
				tag: 'p',
				text: D.Lang.get('profile.team.purchase.' + codeType + '.purchase-text').replace('%USER_EMAIL%', re.email)
			}).append(this.node);

			D.replaceWithNode(text, /%RG_EMAIL%/g, function() {
				return mkE({
					tag: 'a',
					href: 'mailto:' + D.Lang.get('purchase.rg-email'),
					text: D.Lang.get('purchase.rg-email'),
					target: '_blank'
				});
			});

			let ul = mkE({
				tag: 'ul',
				className: 'default-list'
			}).append(this.node);

			re.codes.forEach(code => {
				let codeNode = mkE({
					tag: 'li',
					text: code
				}).append(ul);
				if (re.codes.length === 1) {
					mkE({
						tag: 'a',
						className: 'link-to-team',
						href: D.url('/profile/event/' + this.url.before),
						text: D.Lang.get('purchase.view-team')
					}).append(codeNode);
				}
			});

			if( re.stickers ) {
				mkE({
					tag: 'div',
					className: 'stickers',
					els: [
						{
							tag: 'h4',
							text: D.Lang.get('purchase.stickers.title')
						},
						{
							tag: 'p',
							text: D.Lang.get('purchase.stickers.body')
						},
						{
							tag: 'a',
							className: 'button button-pink button-large',
							href: D.url('/profile/event/' + this.url.before + '/stickers'),
							text: D.Lang.get('purchase.stickers.btn')
						}
					]
				}).append(this.node);
			}

			mkE({
				tag: 'div',
				className: 'success-download',
				els: [
					new T.QRDownload(),
					{
						tag: 'a',
						className: 'button button-pink button-large button-block',
						text: D.Lang.get('purchase.download-app'),
						href: D.url('/get-app')
					}
				]
			}).append(this.node);

			if (this.url.get.is('id')) {
				new T.PopupPoll(DR.popuppolls.GetPoll.TYPE_FIRST_WEB, {
					apiCallParams: {
						paymentId: Number(this.url.get.v('id'))
					}
				}).append(this.node);
			}

			this.ready();
		}
	},
	Section
);